import { useEffect, useState } from "react";

const initialState = {
    numeroCuota: "",
    fechaVencimiento: "",
    montoProgramado: "",
    montoPagado: "0",
    estado: "PENDIENTE",
    fechaPago: "",
};

export default function CuotaForm({ deuda, onClose, onSave }) {
    const [form, setForm] = useState(initialState);

    useEffect(() => {
        setForm(initialState);
    }, [deuda]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        await onSave({
            numeroCuota: Number(form.numeroCuota || 0),
            fechaVencimiento: form.fechaVencimiento,
            montoProgramado: Number(form.montoProgramado || 0),
            montoPagado: Number(form.montoPagado || 0),
            estado: form.estado || "PENDIENTE",
            fechaPago: form.fechaPago || null,
        });
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-card">
                <div className="modal-header">
                    <h3>Agregar cuota: {deuda?.entidad}</h3>
                    <button type="button" onClick={onClose}>X</button>
                </div>

                <form className="grid-form" onSubmit={handleSubmit}>
                    <div>
                        <label>Número de cuota</label>
                        <input
                            name="numeroCuota"
                            type="number"
                            placeholder="Ej. 1"
                            value={form.numeroCuota}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Fecha de vencimiento</label>
                        <input
                            name="fechaVencimiento"
                            type="date"
                            value={form.fechaVencimiento}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Monto programado</label>
                        <input
                            name="montoProgramado"
                            type="number"
                            step="0.01"
                            placeholder="0.00"
                            value={form.montoProgramado}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-actions full-width">
                        <button type="button" onClick={onClose}>Cancelar</button>
                        <button type="submit">Guardar cuota</button>
                    </div>
                </form>
            </div>
        </div>
    );
}